export const EnterpriseData = [
  {
    id: 1,
    customerName: "Cust1",
    assets: 11,
    users: 4,
    alarms: {
      Cleared: 17,
      Intermediate: 22,
      Minor: 1,
      Major: 1,
      Warning: 1,
      Critical: 1,
    },
    asset: {
      Tenants: 2,
      SDWANController: 2,
      vCPEs: 0,
      uCPES: 0,
      SDWANhubs: 0,
      Directors: 0,
    },
    health: {
      Up: {
        physicalPorts: 0,
        configSyncStatus: 5,
        reachabilityStatus: 6,
        serviceStatus: 6,
        interfaces: 18,
        bGPAdjencencies: 16,
        iKEStatus: 14,
        paths: 44,
      },
      Down: {
        physicalPorts: 0,
        configSyncStatus: 1,
        reachabilityStatus: 0,
        serviceStatus: 0,
        interfaces: 0,
        bGPAdjencencies: 0,
        iKEStatus: 10,
        paths: 0,
      },
    },
    services: {
      SDWAN: 10,
      CGNET: 4,
      NEXTGENFIREWALL: 1,
      STATEFULFIREWALL: 2,
      ADC: 2,
    },
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {},
  },
  {
    id: 2,
    customerName: "Cust2",
    assets: 0,
    users: 22,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 102,
      closed: 24050,
      inProgress: 0,
      new: 0,
      onHold: 5,
    },
  },
  {
    id: 3,
    customerName: "Cust3",
    users: 16,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 35,
      closed: 3884,
      inProgress: 0,
      new: 0,
      onHold: 0,
    },
  },
  {
    id: 4,
    customerName: "Cust4",
    users: 12,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 0,
      closed: 24536,
      inProgress: 117,
      new: 2759,
      onHold: 0,
    },
  },
  {
    id: 5,
    customerName: "Cust5",
    users: 22,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 223,
      closed: 26867,
      inProgress: 0,
      new: 0,
      onHold: 0,
    },
  },
  {
    id: 6,
    customerName: "Cust6",
    users: 10,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {},
  },
  {
    id: 7,
    customerName: "Cust7",
    users: 15,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 2,
      closed: 874,
      inProgress: 0,
      new: 0,
      onHold: 0,
    },
  },
  {
    id: 8,
    customerName: "Cust8",
    users: 13,
    assets: 11,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 0,
      closed: 3653,
      inProgress: 0,
      new: 0,
      onHold: 0,
    },
  },
  {
    id: 9,
    customerName: "Cust9",
    users: 7,
    assets: 351,
    alarms: {},
    asset: {},
    health: {},
    services: {},
    hardware: {
      CPU: 6,
      softwareVersion: "20.2.1-GA 47E18E0 20200213",
    },
    predictive: {
      coverage: 38.52,
      accuracy: 81.72,
      aiCorrelated: 0,
      predictiveIncidents: 2393,
    },
    nap: {
      vendor: 9,
      devices: 27,
      pipelines: 200,
      executionSuccess: 42,
      executionFailure: 0,
      executionPartialSuccess: 7,
    },
    incidents: {
      canceled: 0,
      closed: 1207,
      inProgress: 0,
      new: 0,
      onHold: 0,
    },
  },
];
